module.exports = __webpack_public_path__ + "static/img/jincheng2.8afaa3da.jpg";